import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"
import media from "@irati/ui/src/global/media"
import {Label} from "@irati/ui/src/Typography"
import {h2} from "@irati/ui/src/Typography/Heading/styles/index"

interface ImgProps {
  autoHeight?: boolean
}

export const Container = styled(Flex)`
  width: 100%;
  background-color: ${({theme}) => theme.colors.utility.white};

  ${media.tablet`
    padding: 10px 0;
  `}
`

export const ImgWrapper = styled(Flex)`
  height: 80px;
  margin-right: ${({theme}) => theme.spacing.two};
`

export const Img = styled.img<ImgProps>`
  width: 80px;
  height: 80px;
  ${({autoHeight}) => autoHeight && "height: auto;"}
`

export const Description = styled.div`
  flex: 1;
  padding-right: 10px;

  ${media.tablet`
    max-width: 160px;
  `}
`

export const SubTitle = styled(Label)`
  margin-top: ${({theme}) => theme.spacing.one};
`

export const Fiscal = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  margin-left: auto;
`

interface StatusProps {
  pending?: boolean
  cancelled?: boolean
  failed?: boolean
  spent?: boolean
  cleared?: boolean
  expired?: boolean
}

export const Amount = styled.div<StatusProps>`
  display: flex;
  justify-content: flex-end;
  ${h2}
  margin-bottom: 5px;
  text-align: right;
  ${({pending, theme}) =>
    pending &&
    `
    color: ${theme.colors.greys.medium};
  `}
  ${({cancelled, theme}) =>
    cancelled &&
    `
    color: ${theme.colors.greys.medium};
  `}
  ${({failed, theme}) =>
    failed &&
    `
    color: ${theme.colors.error};
  `}
  ${({spent, theme}) =>
    spent &&
    `
    color: ${theme.colors.greys.black};
  `}
  ${({cleared, theme}) =>
    cleared &&
    `
    color: ${theme.colors.tertiary.g_400};
  `}
  ${({expired, theme}) =>
    expired &&
    `
    color: ${theme.colors.greys.black};
  `}
`

export const Status = styled(Label).attrs({
  flush: true,
  large: true
})<StatusProps>`
  text-align: right;
  ${({pending, theme}) =>
    pending &&
    `
    color: ${theme.colors.greys.medium};
  `}
  ${({cancelled, theme}) =>
    cancelled &&
    `
    color: ${theme.colors.greys.mediumDark};
  `}
  ${({failed, theme}) =>
    failed &&
    `
    color: ${theme.colors.error};
  `}
  ${({spent, theme}) =>
    spent &&
    `
    color: ${theme.colors.greys.black};
  `}
  ${({expired, theme}) =>
    expired &&
    `
    color: ${theme.colors.utility.ink};
  `}
`
